"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SliseAd = void 0;
const react_1 = __importDefault(require("react"));
const react_script_hook_1 = __importDefault(require("react-script-hook"));
const DEFAULT_SLISE_HOST = "https://v1.slise.xyz";
const SliseAd = props => {
    var _a, _b, _c, _d, _e, _f;
    const addSlot = react_1.default.useCallback(() => {
        const wnd = window;
        (wnd.adsbyslise = wnd.adsbyslise || []).push({ slot: props.slotId });
        wnd.adsbyslisesync && wnd.adsbyslisesync();
    }, [props.slotId, props.format]);
    react_1.default.useEffect(() => {
        addSlot();
    }, [addSlot]);
    const [_loading, _error] = (0, react_script_hook_1.default)({
        src: `${props.__overrideSliseHost || DEFAULT_SLISE_HOST}/scripts/embed.js`,
        checkForExisting: true,
        async: true,
    });
    return (react_1.default.createElement("ins", { className: "adsbyslise", style: props.style, "data-ad-slot": props.slotId, "data-ad-pub": props.pub, "data-ad-format": props.format },
        react_1.default.createElement("div", { style: {
                width: (_a = props.style) === null || _a === void 0 ? void 0 : _a.width,
                height: (_b = props.style) === null || _b === void 0 ? void 0 : _b.height,
                maxWidth: (_c = props.style) === null || _c === void 0 ? void 0 : _c.maxWidth,
                maxHeight: (_d = props.style) === null || _d === void 0 ? void 0 : _d.maxHeight,
                minWidth: (_e = props.style) === null || _e === void 0 ? void 0 : _e.minWidth,
                minHeight: (_f = props.style) === null || _f === void 0 ? void 0 : _f.minHeight,
            } })));
};
exports.SliseAd = SliseAd;
